<div>
  <label class="text-uppercase input-label" for="{{inputId}}" *ngIf="label !== null">
    {{label}}<span class="text-danger" aria-hidden="true" role="presentation" *ngIf="required"> *</span><span class="sr-only" *ngIf="required"> required</span>
  </label>
  <input #input type="{{inputType}}"
         class="form-control wfm-form-control"
         [value]="textValue"
         [attr.required]="required ? '' : null"
         [attr.aria-required]="required ? 'true' : null"
         [attr.aria-invalid]="hasErrorMsg() ? 'true' : null"
         [attr.aria-describedby]="inputId + '-error'"
         [attr.autocomplete]="wfmAutoComplete==='off'?'one-time-code':''"
         [attr.placeholder]="placeHolder"
         (input)="updateValue($event)"
         (blur)="onBlur($event)"
         (focus)="onFocus($event)"
         [attr.name]="inputName"
         [ngStyle]="inlineStyleObject"
         [ngClass]="{'invalid-input': hasErrorMsg(), 'valid-input': !hasErrorMsg() && !untouched, 'text-right': inputType === 'number'}"
         id="{{inputId}}"
         [attr.maxlength]="maxLength"
         [attr.min]="inputType === 'number' ? minValue : null"
         [attr.max]="inputType === 'number' ? maxValue : null"
  >
  <!-- Visible (sighted-user) error text. aria-hidden keeps it out of browse
       mode so JAWS/NVDA arrow navigation does not land on it as a separate,
       extra focus stop on the error message (the reported "one extra focus on
       'This field is required'"). It is still exposed to AT as the input's
       accessible description: aria-describedby on the input above points here,
       and description computation includes aria-hidden referenced content, so
       the error is announced together with the field on focus (WCAG 4.1.2).
       Auto-announcement when the error first appears is handled by the CDK
       LiveAnnouncer in the component (WCAG 4.1.3), so no persistent live-region
       node is needed here. -->
  <div [id]="inputId + '-error'" class="invalid-feedback" aria-hidden="true" [attr.data-component]="'#' + inputId"
       [ngClass]="{'show-error': hasErrorMsg()}">
    <div *ngIf="hasErrorMsg()">
      <ul *ngIf="showMultilineError">
        <li *ngFor="let msg of serverSideErrMsgs">
          <span class="error-message">{{msg}}</span>
        </li>
        <li *ngFor="let msg of clientSideErrMsgs">
          <span class="error-message">{{msg}}</span>
        </li>
      </ul>
      <div *ngIf="!showMultilineError"><span class="error-message">{{getSingleError()}}</span>
      </div>
    </div>
  </div>
</div>
